'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _resourceConstants = require('../resourceConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map({
    fetching: false,
    fetched: false,
    hasError: false,
    error: undefined
});

// Constants

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _resourceConstants.RESOURCES_FETCHING:
            return state.set('fetching', true);
        case _resourceConstants.RESOURCES_FETCHED:
            return state.withMutations(function (mutateState) {
                return mutateState.set('fetching', false).set('fetched', true).set('fetchedTime', action.fetchedTime).set('hasError', false).set('error', null);
            });
        case _resourceConstants.RESOURCES_FETCH_ERROR:
            return state.withMutations(function (mutateState) {
                return mutateState.set('fetching', false).set('fetched', true).set('hasError', true).set('error', Immutable.fromJS(action.err));
            });
        case _resourceConstants.RESOURCES_MARKED_AS_STALE:
            return state.withMutations(function (mutateState) {
                return mutateState.set('fetching', false).set('fetched', false);
            });
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/reducers/defaultResourceReducer.js
// module id = 470
// module chunks = 0